<template>
  <div id="app">
    <b-navbar
      toggleable="md"
      type="dark"
      variant="dark"
    >
      <b-navbar-toggle target="nav_collapse" />

      <b-navbar-brand to="/">
        <img
          fluid
          height="30"
          src="/static/img/moto_logo.png"
        > CIE
      </b-navbar-brand>

      <b-collapse
        id="nav_collapse"
        is-nav
      >
        <b-navbar-nav>
          <b-nav-item to="/new-project">
            New Project
          </b-nav-item>
          <b-nav-item to="/projects">
            Projects
          </b-nav-item>
          <b-nav-item to="/reports">
            Reports
          </b-nav-item>
          <b-nav-item
            v-show="isNotProdDeployment()"
            to="/break-the-glass-request"
          >
            Break The Glass Request
          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            v-if="!activeUser"
            @click.prevent="login"
          >
            Log In
          </b-nav-item>
          <b-nav-item-dropdown
            v-else
            :text="activeUser.email"
            right
          >
            <!-- Using button-content slot -->
            <b-dropdown-item
              href="#"
              @click.prevent="logout"
            >
              Logout
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-breadcrumb class="t-center">
      <b-link href="https://cieportal-v2.commandcentral.com">
        🎉 Try the new and improved CIE Portal 2.0 (Beta Version). You can always switch back. 🎉
      </b-link>
    </b-breadcrumb>
    <!-- routes will be rendered here -->
    <router-view />
  </div>
</template>

<script>
import api from '@/api';
import routerUtil from '@/router/util';
import {authService} from './authService';

export default {
  name: 'App',
  data() {
    return {
      activeUser: null,
    };
  },
  watch: {
    // every time a route is changed, refresh the activeUser
    $route: 'refreshActiveUser',
  },
  async beforeCreate() {
    this.activeUser = await authService.getUser();
    this.deactivateApiErrorRedirects = api.addResponseErrorHandler(async (error) => {
      if (api.isUnauthorisedError(error)) {
        return this.$router.replace('/forbidden');
      }

      if (api.isUnauthenticatedError(error)) {
        routerUtil.saveReferredBy(this.$route);
        return this.login();
      }

      if (String(error).includes('Network Error')) {
        return this.$router.push({
          name: 'error',
          params: {
            errorMessage: 'Unable to load data. Connect to MSI VPN and try again!',
            errorDetails: String(error),
          },
        });
      }
    });
  },
  destroyed() {
    this.deactivateApiErrorRedirects();
  },
  deactivateApiErrorRedirects() {
    // Waiting to be activated
  },
  methods: {
    async refreshActiveUser() {
      this.activeUser = await authService.getUser();
      if (this.activeUser) {
        this.activeUser.coreId = this.activeUser.preferred_username.split('@')[0];
      }
    },
    login() {
      authService.login();
    },
    async logout() {
      await authService.logout();
      await this.refreshActiveUser();
      this.$router.push('/logged-out');
    },
    isNotProdDeployment() {
      // Use this for "feature flagging" things that are not production-ready yet.
      return !window.location.host.includes('cieportal.commandcentral');
    },
  },
};
</script>

<style>
.col-centered {
  float: none;
  margin: 0 auto;
}
.pointer-cursor {
  cursor: pointer;
}
.t-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
